<div class="dialog-content" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
    <div class="pTxt txt20" fxLayoutAlign="center center">
        Confirm
    </div>
    <p class="txt10 txtCenter">{{content}}</p>
    <mat-dialog-actions>
        <button mat-raised-button class="wTxt" color="accent" (click)="onSubmit()">{{ title }}</button>
        <button mat-raised-button class="wTxt gray" color="primary" matDialogClose>Cancel</button>
    </mat-dialog-actions>
</div>